module.exports = __webpack_public_path__ + "assets/img/36.5e45b72a.png";